import { render } from "./PodftAsideModalHistory.vue?vue&type=template&id=64f29ec1"
import script from "./PodftAsideModalHistory.vue?vue&type=script&lang=js"
export * from "./PodftAsideModalHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__